import ICONS from "../../icons"

const XMLNS = ICONS.xmlns
const FILE_TYPE_MAP = {
  image: ["jpg", "jpeg", "svg"],
  code: ["asm", "asp", "cpp", "css", "exe", "h", "html", "js", "json", "jsp", "jsx", "php", "ts", "vue"],
  video: ["asf", "avi", "mov", "mp4", "mpeg", "mpg", "qt", "rm", "rmvb", "wmv"],
  excel: ["xls", "xlsx", "numbers"],
  ppt: ["pptx", "key"],
  docx: ["doc", "pages"],
  fla: ["flv", "f4v", "swf"],
}

export default {
  name: "mm-icon",
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [String, Boolean],
    },
    fill: {
      type: String,
      default: "currentColor",
    },
    hoverFill: String,
    activeFill: String,
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hover: false,
    }
  },
  computed: {
    iconName() {
      return this.name
    },
    iconData() {
      let data = ICONS[this.name]
      if (!data && this.name.startsWith("file_")) {
        data = this.handleFileType(this.name)
      }

      return data
    },
    className() {
      return ["mm-icon", `mm-icon-${this.name.replace(/_/g, "-")}`]
    },
    style() {
      if (!this.size) {
        return {}
      }
      return {
        height: this.size,
        width: this.size,
      }
    },
  },
  methods: {
    clickHandler(e) {
      this.$emit("click", e)
    },
    getPaths(paths) {
      if (paths instanceof Array) {
        return paths.map(item => <path {...{ attrs: item }} />)
      }

      return <path key="pathSVG" {...{ attrs: paths }} />
    },

    getCircles(circles) {
      if (circles instanceof Array) {
        return circles.map(item => <circle {...{ attrs: item }} />)
      }
      return <circle key="circleSVG" {...{ attrs: circles }} />
    },

    getEllipses(ellipses) {
      if (ellipses instanceof Array) {
        return ellipses.map(item => <ellipse {...{ attrs: item }} />)
      }
      return <ellipse key="ellipseSVG" {...{ attrs: ellipses }} />
    },

    getGroups(groups) {
      if (groups instanceof Array) {
        return groups.map(item => <g>{this.getShapes(item)}</g>)
      }

      return <g key="groupsSVG">{this.getShapes(groups)}</g>
    },

    getLines(lines) {
      if (lines instanceof Array) {
        return lines.map(item => <line {...{ attrs: item }} />)
      }

      return <line key="lineSVG" {...{ attrs: lines }} />
    },

    getShapes(data) {
      const shapes = []

      for (let key in data) {
        switch (key) {
          case "g":
            shapes.push(this.getGroups(data.g))
            break
          case "ellipse":
            shapes.push(this.getEllipses(data.ellipse))
            break
          case "circle":
            shapes.push(this.getCircles(data.circle))
            break
          case "path":
            shapes.push(this.getPaths(data.path))
            break
          case "line":
            shapes.push(this.getLines(data.line))
        }
      }

      return shapes
    },
    hoverHandler(hover) {
      this.hover = hover
    },
    handleFileType(name) {
      let ext = name.split("_")[1]
      for (let key in FILE_TYPE_MAP) {
        if (FILE_TYPE_MAP[key].includes(ext)) {
          return ICONS[`file_${key}`]
        }
      }

      return ICONS.file_unknown
    },
  },
  render(h) { // eslint-disable-line
    return (
      <svg
        class={this.className}
        style={this.style}
        onClick={this.clickHandler}
        onMouseenter={() => this.hoverHandler(true)}
        onMouseleave={() => this.hoverHandler(false)}
        viewBox={this.iconData.viewBox}
        name={this.iconName}
        xmlns={XMLNS}
        fill={
          this.hover
            ? this.hoverFill || this.fill
            : this.active
              ? this.activeFill || this.fill
              : this.fill
        }
      >
        {this.getShapes(this.iconData)}
      </svg>
    )
  },
}
